import { render, staticRenderFns } from "./MailIcon.vue?vue&type=template&id=10fc5e60&scoped=true"
import script from "./MailIcon.vue?vue&type=script&lang=js"
export * from "./MailIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fc5e60",
  null
  
)

export default component.exports